export default [
  {
    path: "/switchboard",
    component: () => import("./Switchboard.vue"),
    children: [
      {
        path: "/switchboard",
        name: "switchboard",
        component: () => import("./Switchboard.vue"),
      },
    ],
  },
  {
    path: "/invite-new-businesses",
    name: "invite-new-businesses",
    component: () => import("./InviteNewBusinesses.vue"),
  },
];
